<script setup lang="ts">
import { NList } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  bordered?: boolean
  size?: 'small' | 'medium' | 'large'
  hoverable?: boolean
  clickable?: boolean
  showDivider?: boolean
  onLoad?: () => void
}>(), {
  bordered: false,
  size: 'medium',
  hoverable: false,
  clickable: false,
  showDivider: true,
})

const emit = defineEmits<{
  'load': []
}>()

const attrs = useAttrs()

const onLoad = () => {
  emit('load')
}
</script>

<template>
  <NList
    :bordered="bordered"
    :size="size"
    :hoverable="hoverable"
    :clickable="clickable"
    :show-divider="showDivider"
    v-bind="attrs"
    @load="onLoad"
  >
    <slot />
  </NList>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
